import * as React from 'react';
import { atom, useAtom, useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';

import { Button, Modal, ModalContent } from '@restworld/ui-ds-base';
import { customImageLoader, getAssetSrc } from '@restworld/utils-common';

import { referencesModalClassName } from './references-consent-modal';
import { isReferencesContentGeneralFlowAtom } from './profile-details-section';

export const referencesRequestSuccessMessageVisibleAtom = atom<boolean>(false);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IReferencesRequestSuccessMessageProps {}
export const ReferencesRequestSuccessMessageModal: React.FunctionComponent<IReferencesRequestSuccessMessageProps> = (
  props
) => {
  const { t } = useTranslation('worker-references-page');
  const [isVisible, setIsVisible] = useAtom(referencesRequestSuccessMessageVisibleAtom);
  const setIsReferencesContentGeneralFlow = useSetAtom(isReferencesContentGeneralFlowAtom);
  return (
    <Modal open={isVisible} onOpenChange={(v) => !v && setIsVisible(false)}>
      <ModalContent
        noPadding
        className={referencesModalClassName}
        title={
          <h5 className="px-4 lg:px-[40px] self-stretch text-center text-neutral-700 text-lg font-semibold">
            {t('references_request_success_message_modal.title')}
          </h5>
        }
        footer={
          <div className="px-4 lg:px-[40px] w-full border-t border-neutral-40 flex flex-col justify-start gap-4 py-4">
            <Button
              fullwidth
              variant="primary"
              onClick={() => {
                setIsVisible(false);
                setIsReferencesContentGeneralFlow(false);
              }}
            >
              {t('references_request_success_message_modal.footer.button.primary')}
            </Button>
          </div>
        }
      >
        <div className="px-4 lg:px-[40px] py-[36px] w-full inline-flex flex-col justify-center items-center gap-8 text-center">
          <div className="flex flex-col justify-start gap-2">
            <h5 className="text-neutral-700 text-lg font-normal">
              {t('references_request_success_message_modal.content.description_1')}
            </h5>
          </div>
          <div className="relative w-[316px] h-[200px]">
            <Image
              src={getAssetSrc('/utils-assets/new-profile-card.png')}
              loader={customImageLoader}
              alt="profile-card"
              fill
            />
          </div>
          <div className="flex flex-col gap-2">
            <h5 className="text-neutral-700 text-lg font-normal">
              {t('references_request_success_message_modal.content.description_2')}
            </h5>
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default ReferencesRequestSuccessMessageModal;
